export const wrapText = (context, text, _x, _y, maxWidth, lineHeight) => {
  const x = _x;
  let y = _y;

  const words = text.split(' ');
  let i = 0;
  let line = '';
  let test;
  let metrics;

  for (i = 0; i < words.length; i++) {
    test = words[i];
    metrics = context.measureText(test);
    while (metrics.width > maxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1);
      metrics = context.measureText(test);
    }
    if (words[i] !== test) {
      words.splice(i + 1, 0, words[i].substr(test.length));
      words[i] = test;
    }

      test = `${line}${words[i]} `;
      metrics = context.measureText(test);

      if (metrics.width > maxWidth && i > 0) {
      context.fillText(line, x, y);
      line = `${words[i]} `;
      y += lineHeight;
    } else {
      line = test;
    }
  }

  context.fillText(line, x, y);
}

export const base64ToBlob = (code) => {
  const parts = code.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = global.window.atob(parts[1]);
  const rawLength = raw.length;

  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; i += 1) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new global.Blob([uInt8Array], { type: contentType });
}

export const downloadFile = (fileName, content) => {
  const aLink = global.document.createElement('a');
  const blob = base64ToBlob(content);

  const evt = global.document.createEvent('HTMLEvents');
  evt.initEvent('click', true, true);
  aLink.download = fileName;
  aLink.href = URL.createObjectURL(blob);

  aLink.dispatchEvent(new global.MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: global.window,
  }));
}
